import {Component, OnInit} from '@angular/core';
import {DataExchangeService} from '../../../../../surface3d/src/lib/API/Public/data-exchange.service';


@Component({
    selector: 'burncase-measuring',
    templateUrl: './measuring.component.html',
    styleUrls: ['./measuring.component.css']
})
export class MeasuringComponent implements OnInit {

    constructor(public dataExchangeService: DataExchangeService) {
    }

    ngOnInit() {
    }

}
